export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 30;
export const USERNAME_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]{2,29}$/;
export const USERNAME_FORMAT_MESSAGE =
  `Use ${USERNAME_MIN_LENGTH}–${USERNAME_MAX_LENGTH} letters, numbers, periods, underscores, or hyphens.`;

export const PASSWORD_MIN_LENGTH = 8;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {string} [email]
 * @returns {boolean}
 */
export function isValidEmail(email) {
  const value = typeof email === "string" ? email.trim() : "";
  return EMAIL_PATTERN.test(value);
}

/**
 * @param {string} [username]
 * @returns {string}
 */
export function usernameFormatError(username) {
  const value = typeof username === "string" ? username.trim() : "";
  if (!value) return "Username is required.";
  if (value.length < USERNAME_MIN_LENGTH || value.length > USERNAME_MAX_LENGTH) {
    return USERNAME_FORMAT_MESSAGE;
  }
  if (!USERNAME_PATTERN.test(value)) {
    return USERNAME_FORMAT_MESSAGE;
  }
  return "";
}

/**
 * @param {string} [password]
 * @returns {{ id: string, label: string, passed: boolean }[]}
 */
export function getPasswordChecks(password) {
  const value = typeof password === "string" ? password : "";
  return [
    {
      id: "length",
      label: `At least ${PASSWORD_MIN_LENGTH} characters`,
      passed: value.length >= PASSWORD_MIN_LENGTH,
    },
    { id: "upper", label: "One uppercase letter", passed: /[A-Z]/.test(value) },
    { id: "lower", label: "One lowercase letter", passed: /[a-z]/.test(value) },
    { id: "number", label: "One number", passed: /[0-9]/.test(value) },
    { id: "special", label: "One special character", passed: /[^A-Za-z0-9]/.test(value) },
  ];
}

/**
 * @param {string} [password]
 * @returns {boolean}
 */
export function passwordIsValid(password) {
  return getPasswordChecks(password).every((check) => check.passed);
}
